import React from 'react'
import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// import Landing Pages
import Index from './pages/index'
import Dealsanddiscounts from './pages/dealsanddiscounts'

// import AuthPages
import Signin from './pages/auth/signin'
import Signup from './pages/auth/signup'

// import account pages
import AccountHome from './pages/account/index'
import Cards from './pages/account/cards'
import CreateNewCard from './pages/account/createnewcard'
import CardDetails from './pages/account/carddetails'
import Dealsandoffers from './pages/account/dealsandoffers'
import AccountSettings from './pages/account/accountsettings'
import Signout from './pages/account/signout'

// import Private route
import PrivateRoutes from './components/account/PrivateRoutes'

// import not found page
import NotFoundPage from './pages/notFound'

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/dealsanddiscounts" element={<Dealsanddiscounts />} />

          {/* auth pages */}
          <Route path="/auth/signin" element={<Signin />} />
          <Route path="/auth/signup" element={<Signup />} />

          {/* logged in account pages - protected routes */}

          {/* private protected routes */}
          <Route element={<PrivateRoutes />}>
            {/* account pages */}
            <Route path="/account" element={<AccountHome />} />
            <Route path="/account/cards" element={<Cards />} />
            <Route path="/account/cards/createnewcard" element={<CreateNewCard />} />
            <Route path="/account/cards/:cardid" element={<CardDetails />} />
            <Route path="/account/dealsandoffers" element={<Dealsandoffers />} />
            <Route path="/account/settings" element={<AccountSettings />} />
            <Route path="/account/signout" element={<Signout />} />
          </Route>

          {/* not found page */}
          <Route path='*' element={< NotFoundPage />} />
        </Routes>

      </BrowserRouter>

    </div>
  );
}


export default App;
